<label for="file-upload" class="file-upload-label gig-button stroked">
  <span>{{ title }}</span>
</label>
<input
  id="file-upload"
  multiple
  type="file"
  [accept]="requiredFileType"
  (change)="onFileInputChange($event.target.files)" />
